export const buildBusinessCardUrl = (companyName, cardId, source) => {
  const baseUrl =
    process.env.REACT_APP_PUBLIC_APP_URL ||
    (typeof window !== "undefined"
      ? window.location.origin
      : "https://businesscardsbw.web.app");
  const businessCardUrl = new URL(
    `/${companyName}/business-card/${cardId}`,
    baseUrl
  );

  if (source) {
    businessCardUrl.searchParams.set("source", source);
  }

  return businessCardUrl.toString();
};
